import { render, staticRenderFns } from "./CompareSwiperComponent.vue?vue&type=template&id=13d5bde0"
import script from "./CompareSwiperComponent.vue?vue&type=script&lang=js"
export * from "./CompareSwiperComponent.vue?vue&type=script&lang=js"
import style0 from "./CompareSwiperComponent.vue?vue&type=style&index=0&id=13d5bde0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports